import { v4 as uuid } from "uuid";
import { z } from "zod";
export const packagePolicyLineItemSchema = z.object({
    contractorPackageId: z.string(),
    created: z.date(),
    id: z.string(),
    projectId: z.string(),
    projectPolicyId: z.string()
});
export const createDefaultPackagePolicy = (projectId, contractorPackageId, projectPolicyId) => packagePolicyLineItemSchema.parse({
    contractorPackageId,
    created: new Date(),
    id: uuid(),
    projectId,
    projectPolicyId
});
